<template>
  <div class="d-inline-block">
    <b-button variant="outline-primary" size="sm" @click="openModal">
      <i class="mdi mdi-account-cog me-1"></i>
      Manage Supra Urgent Approvers
    </b-button>
    <b-modal
      v-model="dialog"
      title="Manage Supra Urgent Approvers"
      centered
      hide-footer
      size="xl"
    >
      <div v-if="loading" class="text-center py-4">
        <b-spinner variant="primary" small></b-spinner>
      </div>
      <div v-else-if="users.length === 0" class="text-center py-3">
        <p class="text-muted mb-0">No Supra Urgent approvers found.</p>
      </div>
      <template v-else>
        <b-tabs content-class="mt-3" v-model="activeTab">
          <b-tab
            v-for="(organ, index) in organTabs"
            :key="index"
            :title="organ + ' (' + getOrganUsers(organ).length + ')'"
          >
            <b-table
              :items="getOrganUsers(organ)"
              :fields="fields"
              small
              striped
              responsive
              hover
            >
              <template #cell(sno)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(name)="data">
                {{ data.item.first_name }} {{ data.item.last_name }}
              </template>
              <template #cell(ALF_approver)="data">
                <b-form-checkbox
                  :checked="data.value == 1"
                  :disabled="toggling"
                  switch
                  @change="toggleApprover(data.item, $event)"
                >
                  {{ data.value == 1 ? "Yes" : "No" }}
                </b-form-checkbox>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
        <div class="mt-2">
          <small class="text-muted">
            Total: {{ approverCount }} active approver{{ approverCount > 1 ? "s" : "" }}
          </small>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import hospitalService from "../../assets/services/hospital.service";

export default {
  name: "ManageALFApprovers",
  data() {
    return {
      dialog: false,
      loading: false,
      toggling: false,
      activeTab: 0,
      users: [],
    };
  },
  computed: {
    fields() {
      let list = [
        { key: "sno", label: "S.No" },
        { key: "name", label: "Name" },
      ];
      if (this.isAdmins) {
        list.push({ key: "hospital_name", label: "Hospital" });
      }
      list.push(
        { key: "email_id", label: "Email" },
        { key: "phone_number_1", label: "Phone" },
        { key: "ALF_approver", label: "Supra Urgent Approver" }
      );
      return list;
    },
    organTabs() {
      let organs = new Set();
      this.users.forEach((u) => {
        if (u.organ_name) {
          u.organ_name.split(", ").forEach((o) => {
            organs.add(o.trim());
          });
        }
      });
      let list = Array.from(organs).sort();
      if (list.length === 0) list.push("All");
      return list;
    },
    approverCount() {
      return this.users.filter((u) => u.ALF_approver == 1).length;
    },
  },
  methods: {
    getOrganUsers(organ) {
      if (organ === "All") return this.users;
      return this.users.filter((u) => {
        if (!u.organ_name) return false;
        let organs = u.organ_name.split(", ").map((o) => o.trim());
        return organs.includes(organ);
      });
    },
    async openModal() {
      this.dialog = true;
      await this.fetchUsers();
    },
    async fetchUsers() {
      this.loading = true;
      try {
        const { data } = await hospitalService.getALFApprovers();
        if (data.status && data.list) {
          this.users = data.list;
        }
      } catch (error) {
        this.$alert.show("Error loading approvers");
      } finally {
        this.loading = false;
      }
    },
    async toggleApprover(item, checked) {
      this.toggling = true;
      try {
        const { data } = await hospitalService.toggleALFApprover(
          item.registration_id,
          checked ? 1 : 0
        );
        if (data.status) {
          if (!checked) {
            this.users = this.users.filter(
              (u) => u.registration_id !== item.registration_id
            );
          } else {
            item.ALF_approver = 1;
          }
          this.$alert.show(data.msg, "success");
        } else {
          this.$alert.show(data.msg || "Failed to update");
        }
      } catch (error) {
        this.$alert.show("Error updating approver");
      } finally {
        this.toggling = false;
      }
    },
  },
};
</script>
